/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { LanguageViewModel } from './LanguageViewModel'; 

export function getLanguageOptions(language: string, onSuccess?: (result: LanguageViewModel) => void) {
	return queryOptions({
		queryKey: ['language', language],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/languages/queries/getlanguage/' + language;
			const resp = await axios.get<LanguageViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(language)
	});
}